import { memoize } from 'lodash-es';
// TODO [FILE-77]: Investigate why the loadScript util from
// pplx/frontend/common/loadScript does not work here. Refactor
// this file to use loadScript once the issue is resolved.
const GAPI_SCRIPT_ID = 'google-drive-picker-gapi-script';
const GIS_SCRIPT_ID = 'google-identity-services-script';
export const loadGoogleIdentityServicesSdk = memoize(async function loadGoogleIdentityServicesSdk() {
    if (document.getElementById(GIS_SCRIPT_ID)) {
        return;
    }
    return new Promise((resolve, reject) => {
        // ast-grep-ignore: no-manual-script-creation
        const gisScript = document.createElement('script');
        gisScript.src = 'https://accounts.google.com/gsi/client';
        gisScript.id = GIS_SCRIPT_ID;
        gisScript.onload = () => resolve();
        gisScript.onerror = reject;
        document.body.appendChild(gisScript);
    });
});
export const loadGoogleApiSdk = memoize(async function loadGoogleApiSdk() {
    if (document.getElementById(GAPI_SCRIPT_ID)) {
        return;
    }
    return new Promise((resolve, reject) => {
        // ast-grep-ignore: no-manual-script-creation
        const gapiScript = document.createElement('script');
        gapiScript.src = 'https://apis.google.com/js/api.js';
        gapiScript.id = GAPI_SCRIPT_ID;
        gapiScript.onload = () => {
            window.gapi.load('picker', {
                callback: resolve,
                onerror: reject,
            });
        };
        gapiScript.onerror = reject;
        document.body.appendChild(gapiScript);
    });
});
//# sourceMappingURL=loadGoogleSdk.js.map